import { useEffect } from 'react';

import usePathname from 'app-migration/hooks/usePathname';

import { useStores } from './use-stores';

const useFinancialsExternalSources = () => {
    const { uiStore, externalSourcesStore } = useStores();

    const pathname = usePathname();

    // Check watchlist view
    const isWatchlistFinancialsView = uiStore.watchlistView === 'financials' && !uiStore.watchlistCollapsed;

    // Check if it's financials page
    const isFinancialsPage = ['/events/financials', '/watchlist'].includes(pathname);

    // Check if we want to load the data
    const loadData = isWatchlistFinancialsView || isFinancialsPage;

    useEffect(
        () => {
            if (loadData) {
                // Historical data
                externalSourcesStore.loadSPXSeries('day');
                externalSourcesStore.loadQQQSeries('day');
                externalSourcesStore.loadEuroSeries('day');
                externalSourcesStore.loadYenSeries('day');
                externalSourcesStore.loadRubSeries('day');
                // WTI data from twelvedata is for Spot, they don't have data for ICE Futures.
                // externalSourcesStore.loadWtiSeries('day');

                // Last value
                externalSourcesStore.loadSPXLastValue('fast');
                externalSourcesStore.loadQQQLastValue('fast');
                externalSourcesStore.loadEuroLastValue('fast');
                externalSourcesStore.loadYenLastValue('fast');
                externalSourcesStore.loadRubLastValue('fast');
                // WTI data from twelvedata is for Spot, they don't have data for ICE Futures.
                // externalSourcesStore.loadWtiLastValue('fast');

                // Combined data - last and historical
                // Commented out because it's returning 429
                // externalSourcesStore.loadUtenData('slow');
            }
        }, // TODO: check or fix hooks error
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [loadData],
    );
};

export default useFinancialsExternalSources;
